<template>
  <div class="crop-view  fade-in-fwd crop-view-myProject-ht">
    <img
      alt=""
      :src="src"
      class="d-block mw-100 sr-only"
      ref="imgRef"
      :style="getStyleObject"
    />
  </div>
</template>
<script>
import Cropper from "cropperjs";
import { mapActions, mapGetters } from "vuex";

export default {
  props: {
    src: "",
    ratio: Number,
    height: {
      type: String,
      default: "300px"
    },
    onCropChange: {
      type: Function,
      default: () => {}
    },
    onInit: {
      type: Function,
      default: () => {}
    },
    options: {
      type: Object
    },
    imageSrc: {
      type: String
    }
  },

  data() {
    return {
      isLoading: true,
      cropper: null,
      imageSrcNew: null,
      cover: this.$resourceString['common.accounts.Label.Cover'],
      thumbnail: this.$resourceString['common.accounts.Label.Thumbnail'],
    };
  },

  mounted() {
    const imgElement = this.$refs.imgRef;

    if (imgElement.complete) {
      this.initCropper();
    } else {
      imgElement.onload = () => {
        this.initCropper();
      };
    }
  },

  updated() {},

  watch: {
    ratio(newRatio) {
      if (this.cropper) {
        this.cropper.setAspectRatio(newRatio);
      }
    },

    src(newSrc) {
      if (this.cropper) {
        this.cropper.replace(newSrc);
      }
    }
  },

  computed: {
    ...mapGetters({
      getImageData: "myProject/getImageData",
      getTab: "myProject/getTab"
    }),
    getStyleObject() {
      return {
        transform: "translate3d(0, 0, 0)"
      };
    }
  },
  methods: {
    ...mapActions({
      setImageData: "myProject/setImageData",
      setImagelement: "myTray/setImagelement",
      setImageCropData: "myProject/setImageCropData"
    }),

    handleCropChange(cropper, cropData) {
      this.handleCropData(
        this.getTab === "cover" ? "cover" : "thumbnail",
        true,
        { imgRef: this.$refs.imgRef, cropperNew: cropper, cropData: cropData }
      );
    },

    handleInit(cropper) {
      this.isLoading = false;
      this.handleCropData(
        this.getTab ===  "cover" ? "cover" : "thumbnail",
        true,
        { imgRef: this.$refs.imgRef, cropperNew: cropper }
      );
    },

    initCropper() {
      const imgElement = this.$refs.imgRef;
      if (!imgElement) {
        return;
      }

      this.cropper = new Cropper(imgElement, {
        ...this.options,
        ready: event => this.handleInit(this.cropper),
        crop: event => this.handleCropChange(this.cropper, event.detail),
        aspectRatio: this.ratio
      });
    },

    handleCropData(key, isInit, { cropperNew, cropData }) {
      const cropper = cropperNew;
      if (isInit && this.getImageData?.[key]) {
        cropper.setCropBoxData(this.getImageData[key].cropBoxData);
      } else {
        const imgElement = this.$refs.imgRef;
        this.setImageData({ key, cropperData: cropper });
        this.setImagelement({ imgElement });
        if (cropData) {
          this.setImageCropData({ key, cropperData: cropData });
        }
      }
    }
  },

  beforeDestroy() {
    if (this.cropper) {
      this.cropper.destroy();
    }
  }
};
</script>
